import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  faAngleLeft,
  faEye,
  faGear,
  faPenToSquare,
  faShareNodes
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserContext } from '../../contexts/UserContext';
import SlideEditorSettingsModal from 'components/modals/SlideEditorSettingsModal';
import ToastWrapper from '../../components/Toast';
import { useSlideEditorContext } from '../../providers/SlideEditorProvider';
import {
  SET_DELETE_MODAL,
  SET_EDIT_MODE,
  SET_SLIDE_EDIT_MODE
} from '../../reducers/SlideEditorReducer';

interface IProps {
  handleSaveSlide?: () => void;
}

const SlideNavBar = ({ handleSaveSlide }: IProps) => {
  const { slideEditorDispatch, editMode, slideEditMode } =
    useSlideEditorContext();
  const [toastText, setToastText] = useState('');
  const [showToast, setShowToast] = useState(false);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const { projectData } = useSlideEditorContext();
  const [isCopy, setIsCopy] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const handleClickSaveButton = () => {
    if (handleSaveSlide) {
      handleSaveSlide();
    }
    slideEditorDispatch({ type: SET_DELETE_MODAL, payload: false });
    slideEditorDispatch({ type: SET_SLIDE_EDIT_MODE, payload: false });
    setToastText('saved...!');
    setShowToast(true);
  };

  const handleClickEditButton = () => {
    handleEditClick();
    setToastText('Entering edit...');
    setShowToast(true);
  };

  const handleSettingsClick = () => {
    if (editMode) return;

    // slideEditorDispatch({
    //   type: HANDLE_SETTINGS_SELECT,
    //   payload: {
    //     pitchDeckId: pitchDeckData?.pitchDeckId || '',
    //     statusId: pitchDeckData?.statusId || '',
    //     trackingEnabled: pitchDeckData?.trackingEnabled ?? false,
    //     openSettingsModal: true
    //   }
    // });
  };

  const handleEditClick = () => {
    slideEditorDispatch({ type: SET_SLIDE_EDIT_MODE, payload: true });
    slideEditorDispatch({ type: SET_EDIT_MODE, payload: true });
  };

  const handleShareClick = async () => {
    setIsShareModalOpen(!isShareModalOpen);

    const shareData = {
      title: 'NuPitch',
      text: 'Check out this pitch deck for the project: ',
      url: window.location.href
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        console.log('🥳 Shared via web share API.');
      } catch (error) {
        console.log(`😢 ${error}`);
      }
    } else {
      console.log('😢 Your browser does not support the web share API.');
    }
  };

  const handleExitClick = () => {
    navigate('/apps/project-management/project-board-view/');
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(
      () => {
        setIsCopy(true);
        setToastText('Liên kết đã được sao chép!');
        setShowToast(true);
      },
      err => {
        setIsCopy(false);
        setToastText('Sao chép liên kết thất bại!');
        setShowToast(true);
        console.error('Could not copy text: ', err);
      }
    );
  };

  const truncateUrl = (url: string, maxLength: number) => {
    if (url.length <= maxLength) return url;
    const start = url.slice(0, maxLength / 2);
    const end = url.slice(-maxLength / 2);
    return `${start}...${end}`;
  };

  return (
    <nav className="navbar sticky-top navbar-dark">
      <div className="container-fluid">
        {user ? (
          <button className="btn p-0" onClick={handleExitClick}>
            <FontAwesomeIcon icon={faAngleLeft} size="lg" />
          </button>
        ) : null}

        <h5 className="mt-1">{projectData?.title}</h5>

        {user ? (
          <button
            className="btn p-0"
            onClick={
              slideEditMode ? handleClickSaveButton : handleClickEditButton
            }
          >
            <FontAwesomeIcon
              icon={slideEditMode ? faEye : faPenToSquare}
              size="lg"
            />
          </button>
        ) : null}

        {user && !slideEditMode ? (
          <button className="btn p-0" onClick={handleSettingsClick}>
            <FontAwesomeIcon icon={faGear} size="lg" />
          </button>
        ) : null}

        {user && !slideEditMode ? (
          <div className="position-relative">
            <button className="btn p-0" onClick={handleShareClick}>
              <FontAwesomeIcon icon={faShareNodes} size="lg" />
            </button>
            {isShareModalOpen && (
              <div
                className="p-3 position-absolute end-0 rounded-2 d-flex justify-content-center flex-column"
                style={{
                  backgroundColor: 'white',
                  top: 40,
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                  animation: 'fadeIn 0.3s'
                }}
              >
                <p>{truncateUrl(window.location.href, 45)}</p>
                <button
                  className="btn"
                  style={{
                    backgroundColor: '#7731d8',
                    color: 'white'
                  }}
                  onClick={handleCopyLink}
                >
                  {!isCopy ? 'Copy' : 'Copied'}
                </button>
              </div>
            )}
          </div>
        ) : null}
      </div>
      {user ? <SlideEditorSettingsModal /> : null}
      <ToastWrapper
        showToast={showToast}
        message={toastText}
        setShowToast={setShowToast}
      />
    </nav>
  );
};

export default SlideNavBar;
